import { render, staticRenderFns } from "./StudentAnswerDetail.vue?vue&type=template&id=3ed0101f&scoped=true&"
import script from "./StudentAnswerDetail.vue?vue&type=script&lang=js&"
export * from "./StudentAnswerDetail.vue?vue&type=script&lang=js&"
import style0 from "./StudentAnswerDetail.vue?vue&type=style&index=0&id=3ed0101f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed0101f",
  null
  
)

export default component.exports